import {computed, observable} from 'mobx';
import BuildApi from '../actions/BuildApi';
import {isNumeric, numberToPercentage} from '../lib/utils';
import Promise from 'bluebird';
import {toJS} from 'mobx';
import {cloneDeep} from 'lodash';
var numeral = require('numeral');

class Sector{

	@observable userSectorId
	@observable sectorRefId
	@observable sectorCode
	@observable name
	@observable size
	@observable sizePercentage
	@observable positionPrice
	@observable stopLoss
	@observable targetAmount
	@observable targetPercentage
	@observable screeners
	@observable selected
	@observable etf
	@observable isTrailing
	@observable sizeError
	@observable etfError
	@observable stopLossError
	@observable positionPriceError
	@observable targetPercentageError
	@observable targetAmountError
	@observable strategies
	@observable sectorValue
	@observable sectorEquity
	@observable backtestEtfSize

	_isNumeric(n) {
	    return !isNaN(parseFloat(n)) && isFinite(n);
	}

	_isPercentage(n){
		if(!this._isNumeric(n)){
			return false
		}
		return (n >= 0 && n <= 100)
	}

	validateSize(){
		// console.log("vlidate size")
		if(!this._isNumeric(this.size)){
			this.sizeError = "not a number"
			return false
		}else if(this.size < 0 ){
			this.sizeError = "bad value"
			return false
		}
		this.sizeError = ''
		return true
	}

	validateEtf(){

		if(!this._isPercentage(this.etf)){
			this.etfError = "bad value"
			return false
		}
		this.etfError = ''
		return true
	}

	validateStoploss(){

		if(!this._isPercentage(this.stopLoss) || this.stopLoss > 99){
			this.stopLossError = "bad value"
			return false
		}
		this.stopLossError = ''
		return true
	}

	validatePositionPrice(){
		if(!this._isPercentage(this.positionPrice)){
			this.positionPriceError = "bad value"
			return false
		}
		this.positionPriceError = ''
		return true
	}

	validateTargetPercentage(){
		if(!this._isPercentage(this.targetPercentage)){
			this.targetPercentageError = "bad value"
			return false
		}
		this.targetPercentageError = ''
		return true
	}

	validateTargetAmount(){
		if(!this._isNumeric(this.targetAmount)){
			this.targetAmountError = "not a number"
			return false
		}else if(this.targetAmount < 0 || this.targetAmount > 1){
			this.targetAmountError = "bad value"
			return false
		}
		this.targetAmountError = ''
		return true
	}

	validateStrategies(){
		console.log("check strat")
		for(let s of this.strategies){
			console.log(s)
			if(s.field == "8" && (!this._isPercentage(s.vts) || !this._isPercentage(s.svts) )|| s.field == "9" && !this._isPercentage(s.rel_to_sec) ){
				return false
			}
		}
		return true
	}

	validate(){
		// console.log("validateing sector",this.name)
		 const errors = []

		if(!this.validateSize()){

			 errors.push("Error: chosen size in "+this.name+" is not valid")
		}
		// if(!this.validateEtf()){

		// 	 errors.push("Error: ETF size of "+this.name+" should be between 0-100")
		// }
		if(!this.validateStoploss()){

			 errors.push("Error: Stoploss of "+this.name+" should be between 0-20")
		}
		if(!this.validatePositionPrice()){

			 errors.push("Error: Positoin price of "+this.name+" should be between 0-100")
		}
		if(!this.validateTargetPercentage()){

			 errors.push("Error: Target percentage of "+this.name+" should be between 0-100")
		}
		if(!this.validateTargetAmount())	{

			 errors.push("Error: Target amount of "+this.name+" should be between 0-1")
		}
		if(!this.validateStrategies()){

			errors.push("Error: Strategy values of "+this.name+" should be between 0-100")
		}

		return errors;
	}

	isValid(){
		return !(
			this.sizeError ||
			this.etfError ||
			this.stopLossError ||
			this.positionPriceError ||
			this.targetPercentageError ||
			this.targetAmountError
			)
	}



	constructor(

		SectorCode
		,Name
		,Size
		,SizePercentage
		,PositionPrice
		,Stoploss
		,TargetAmount
		,TargetPercentage
		,SectorSecuritySize
		,Screeners
		,Strategies
		,Trailing
		,Selected
		,SectorValue
		,SectorEquity
		,UserSectorId
		,SectorRefId
		,etf
	){

		this.backtestEtfSize = 0
    this.userSectorId = UserSectorId
		this.sectorRefId = SectorRefId
		this.sectorCode  = SectorCode
		this.name = Name
		// this.symbol = Sym
		this.size = Size !== undefined ? Size : 10000
		this.sizePercentage = SizePercentage !== undefined ? SizePercentage : 10
		this.positionPrice = PositionPrice !== undefined ? PositionPrice : 10
		this.stopLoss = Stoploss !== undefined ? Stoploss : 10
		this.targetAmount = TargetAmount !== undefined ? TargetAmount : 0
		this.targetPercentage = TargetPercentage !== undefined ? TargetPercentage : 0
		this.screeners = Screeners ? Screeners : []
		this.strategies = Strategies ? Strategies : []

		this.etf = etf !== undefined ? etf : 0//SectorSecuritySize !== undefined ? SectorSecuritySize : 0
		this.isTrailing = Trailing ? Trailing : true
		this.sizeError = ""
		this.etfError = ""
		this.stopLossError = ""
		this.positionPriceError = ""
		this.targetPercentageError = ""
		this.targetAmountError = ""
		this.selected = Selected !== undefined ? Selected : true
		this.sectorValue = SectorValue !== undefined ? SectorValue : 0
		this.sectorEquity = SectorEquity !== undefined ? SectorEquity : 0
		if(!this.size){
			this.selected = false
		}else{
			this.selected = true
		}
	}
}

// class Screener{
// 	@observable field
// 	@observable minVal
// 	@observable name
// 	@observable maxVal
// 	@observable valType
// 	@observable posType


// 	constructor(Field,Name, MinVal, MaxVal, ValType, PosType){

// 		this.field = Field
// 		this.name = Name
// 		this.minVal = MinVal
// 		this.maxVal = MaxVal
// 		this.valType = ValType
// 		this.posType = PosType

// 	}
// }

export class BuildStore{


	@observable sectors = []
	@observable userDetails = {
		firstName : "",
		lastName : "",
		email : "",
		nickname : "",
		avatar:"img/dbranja_default_avatar.png",
	}
	@observable totalSize = 0
	@observable barProgress = 0
	@observable date = ""
	@observable endDate = ""
	@observable allocation = ""
	@observable buildStatus = ""
	@observable buildMessage = ""
	@observable backtestResponse = ""
	@observable backtestStatusMsg = ""
	@observable backtestStatusCode = ""
	@observable etfTools = []
	@observable	resolution = 0

	default_sectors= [];


	constructor(){
		this.default_sectors[1]  = {name:"Basic Materials",val:1}
		this.default_sectors[2]  = {name:"Biotechnology",val:2}
		this.default_sectors[3]  = {name:"Energy",val:3}
		this.default_sectors[4]  = {name:"Consumer Goods",val:4}
		this.default_sectors[5]  = {name:"Financial",val:5}
		this.default_sectors[6]  = {name:"Healthcare",val:6}
		this.default_sectors[7]  = {name:"Industrial Goods",val:7}
		this.default_sectors[9]  = {name:"Services",val:9}
		this.default_sectors[10] = {name:"Technology",val:10}
		this.default_sectors[11] = {name:"Utilities",val:11}
	}



	initSectors = () =>{

		const self = this

		BuildApi.getDefaultSectors().then(function(result){
				Object.keys(result.sectors).forEach(function(sectorId){
					let sector = result.sectors[sectorId]
					let newSec = new Sector(0,sector.name)
					newSec.sectorRefId = sectorId
					self.sectors.push(newSec)
				})
		})

	}

	getSectors(){
		const self = this

		self.sectors.replace([])
		return BuildApi.getPortfolio().then(function(result){

			// console.log("---sectors",result)
			if(result){
				if(result['user_data']){
					self.userDetails.firstName = result['user_data'].firstName
					self.userDetails.lastName  = result['user_data'].lastName
					self.userDetails.email     = result['user_data'].email
					self.userDetails.nickname  = result['user_data'].nickname
					self.userDetails.teamUpdatePeriod = (result['user_data'].update_team_period && result['user_data'].update_team_period > 0 ) ? result['user_data'].update_team_period : 1
					self.userDetails.firstTime = result['user_sectors_count'] ? false : true
					if(result['user_data'].avatar){
						self.userDetails.avatar = result['user_data'].avatar
					}
					// console.log("-=-=-=-=-=-=-",result['user_sectors_count'])
				}

				if(self.userDetails.firstTime){
					self.totalSize = result.portfolioSize
				}else{
					self.totalSize = result.account_value
				}

				if(!self.userDetails.firstTime){
					result.sectors.forEach(function(s){
						// if(typeof self.default_sectors[s.val] !== 'undefined'){
							// console.log("--------- screeners")
							// console.log(cloneDeep(s.screeners))
							// console.log("=-=-=-=-=-=-=")

							self.sectors.push(new Sector(
								s.val,
								s.name,
								s.size,
								s.size_percentage,
								s.position_price,
								s.stoploss,
								s.target_amount,
								s.target_percentage,
								s.sector_security_size,
								s.screeners,
								self.formatStrategiesFromServer(s),
								false,
								false,
								s.sector_value,
								s.sector_equity,
								s.id,
								s.sector_ref_id,
								s.etf));
						// }
					})
				}else{
					self.initSectors()
				}
			}



			return Promise.resolve(true)
			// console.log("-=-=-=-=-",self.sectors);

		},function(err){

			console.log(err);
			return Promise.reject(false)
		})
	}

	bindAllocation(allocation){
		// console.log("lulululu")
		this.sectors.forEach(function(s){
			s["size"] = 400//allocation[s.name]
			// console.log(s)
		})
	}

	fetchAllocation(){

		const self = this
		// self.bindAllocation(1)
		var data = {}
		var sectorNames = []

		this.sectors.forEach(function(s){
			sectorNames.push(s['name'])
		})

		data["sectors"] = sectorNames
		data["allocation"] = this.allocation
		data["budget"] = this.totalSize
		var sectors = this.sectors
		self.barProgress = 10
		setTimeout(function(){
			self.barProgress += 50;
			if(self.barProgress > 100){
				self.barProgress = 100
			}
		},500)

		return BuildApi.getAllocation(data).then(function(res){
			// self.initSectors()
			// self.bindAllocation(res)
			self.sectors.forEach(function(s){
				s["size"] = parseFloat(res[s.name])
				s["sizePercentage"] = numeral( numberToPercentage(res[s.name],self.totalSize) ).format('0.[00]')
				s['selected'] = true
				// console.log(s)
			})
			self.barProgress = 100
			setTimeout(function(){
				self.barProgress = 0;
			},500)
			const ss = self.sectors
			// self.sectors.replace([])
			self.sectors.replace(ss)
			return Promise.resolve(true)
			// console.log("kkkkk")
		},function(err){
			console.log(err)
			return Promise.reject(false)
		})
		// this.sectors.replace(sectors)

	}

	// formatPosType(PosType){
	// 	switch(posType){
	// 		case ''
	// 	}
	// }

	formatScreeners(screeners){
		// const self = this
		var FScreeners = [];
		if(screeners)
		screeners.forEach(function(s){

			var rangeType = 2

			// if((s.minVal === "" || s.minVal == null) && (s.maxVal === "" || s.maxVal == null)){
			//     rangeType = 3
			// }
			// else if((s.maxVal === "" || s.maxVal == null) && (s.minVal !== "" && s.minVal != null)){
			//     rangeType = 0
			// }
			// else if(( s.maxVal !== "" && s.maxVal != null)&& (s.minVal === "" || s.minVal == null)){
			//     rangeType = 1
			// }
			if(!isNumeric(s.minVal) && !isNumeric(s.maxVal)){
			    rangeType = 3
			}
			else if(!isNumeric(s.maxVal) && isNumeric(s.minVal)){
			    rangeType = 0
			}
			else if(isNumeric(s.maxVal) && !isNumeric(s.minVal)){
			    rangeType = 1
			}

			FScreeners.push({

				screener_name:s.field,
				min_value:s.minVal,
				max_value:s.maxVal,
				pos_type:s.pos_type,
				selector: s.selector,
				range_type: rangeType
			})
		})
		return FScreeners
	}

	formatStrategiesFromServer(sector){
		var strategies = [];
		// console.log(sector)
		// if(sector.logic == 8){
		// 	strategies.push({field:"8", name:'Short on Sector', vts:sector.vts_percentage, svts:sector.svts_percentage})
		// }
		// // rel_to_sec


		// if(sector.logic == 9){
		// 	strategies.push({field:"9", name:'Relative to Sector', rel_to_sec:sector.rel_to_sec_percentage})
		// }
		for (var i = 0; i < sector.strategies.length; i++) {
			switch (parseInt(sector.strategies[i])){
				case 8:
					strategies.push({field:"8", name:'Short on Sector', vts:sector.vts_percentage, svts:sector.svts_percentage})
					break;
				case 9:
					strategies.push({field:"9", name:'Relative to Sector', rel_to_sec:sector.rel_to_sec_percentage})
					break
				case 10:
					strategies.push({
						field:"10",
						name:'Relative to Earning Announcement',
						vt_no_order_before_ea: sector.vt_no_order_before_ea,
						vt_alert_before_ea: sector.vt_alert_before_ea,
						vt_close_before_ea: sector.vt_close_before_ea
					})
					break;
			}
		}
		return strategies
	}
	formatSectorsForTest(sectors){

		const self = this
		let sectorsArr = self.formatSectors(sectors)
		return  sectorsArr.reduce(function ( sectorsObj, sector ) {
	    sectorsObj[sector['sector_ref_id']] = sector
	    return sectorsObj
		}, {})
	}
	formatSectors(sectors){
		const self = this
		var formatedSectors = [];
		sectors.forEach(function(s){
			// console.log(s.strategies)

			formatedSectors.push({
				name: s.name,
				val: s.sectorCode,
				backtest_etf_size:	s.backtestEtfSize,
				user_sector_id: s.userSectorId,
				sector_ref_id: s.sectorRefId,
				size_percentage: s.selected ? s.sizePercentage : 0,
				realSize: s.selected ? s.size : 0,
				positionPrice: s.positionPrice,
				sector_security_size: s.etf,
				stoploss: s.stopLoss,
				target_amount: s.targetAmount,
				target_percentage: s.targetPercentage,
				isTrailing: s.isTrailing,
				// analysts:[],
				logic:s.strategies.length ? s.strategies[0].field : 0,
				long_trigger_high_percentage:2,
				long_trigger_low_percentage:0,
				ratings_to_copy:[],
				short_trigger_low_percentage:2,
				sp_500_only:false,
				svts_percentage: s.strategies.length ? s.strategies[0].svts : 0,
				symbol:"",
				up_down_ratio:1,
				vts_percentage: s.strategies.length ? s.strategies[0].vts : 0,
				screeners:self.formatScreeners(s.screeners),
				rel_to_sec:s.strategies.length && s.strategies[0].field == "9" ? s.strategies[0].rel_to_sec : 0,
				strategies: s.strategies,//self.formatStrategies(s),
				editScreeners: true,
				etf: s.etf ? s.etf : 0,
				//selected: s.selected
			})
		})

		return formatedSectors
	}

	editSectors(){
		// console.log("-=-=-=-=-=");
		const self = this
		var data = {"teamUpdatePeriod":this.userDetails.teamUpdatePeriod,"portfolioSize":this.totalSize, "sectors":[]}
		this.buildStatus = "pending"
		this.buildMessage = ""//"editing portfolio..."
		data.newBuild = true
		data.sectors = this.formatSectors(this.sectors)

		return BuildApi.editPortfolio({"pf_data":data}).then(function(res){
			console.log("edited");
			self.buildStatus = "success"
			self.buildMessage = "successfully edited portfolio"
			return Promise.resolve(true)
		},function(err){
			self.buildStatus = "error"
			self.buildMessage = "error while editing portfolio"
			return Promise.reject(false)
		})
	}

	updateTeam(){
		const self = this
		return BuildApi.updateTeam()
		// BuildApi.updateTeam().then(function(res){

		// 	if(res.res_code == 301){
		// 		console.log('=== success ==')
		// 		self.buildStatus = "success"
		// 		self.buildMessage = "successfully updated team"
		// 	}else{
		// 		console.log('===== error ===')
		// 		self.buildStatus = "error"
		// 		self.buildMessage = "error while updating team"
		// 	}
		// },function(err){
		// 	console.log('==== error ===')
		// 	self.buildStatus = "error"
		// 	self.buildMessage = "error while updating team"
		// });
	}

	@computed get createSectors(){
		// console.log("-=-=-=-=-=");
		const self = this
		var data = {"portfolioSize":this.totalSize, "sectors":[],allocation:this.allocation}
		data.newBuild = true
		data.sectors = this.formatSectors(this.sectors)
		BuildApi.createPortfolio({"pf_data":data}).then(function(res){
			console.log("edited");

		})
	}

	runBacktest(etfTools){
		// console.log("-=-=-=-=-=", this.resolution);
		let self = this

		const thisDate = new Date();

    thisDate.setHours(0, 0, 0, 0);

		if (!this.date || this.date == "") {
			this.date = thisDate;
		}

		if (!this.endDate || this.endDate == "") {
			this.endDate = thisDate;
		}

		var data = {
			"teamUpdatePeriod":this.userDetails.teamUpdatePeriod,
			"resolution":this.resolution,
			"portfolioSize":this.totalSize,
			"newBuild":true,
			"date":this.date,
			"endDate":this.endDate,
			"autoAnalysts":true,
			"sectors":this.formatSectorsForTest(this.sectors),
			"etf_tools":etfTools
		}

		BuildApi.backtest({"pf_data":data}).then(function(res){
			// console.log("edited");
			// console.log("======backtest",res)
			if(res.msg){
				// console.log(res)
				self.backtestResponse = res.msg
			}
			else{
				self.backtestResponse = "Error occourd try again later."
			}
		},function(){
			self.backtestResponse = "Error occourd try again later."
		})
	}

	backtestStatus(){
		const self = this
		BuildApi.getBacktestStatus().then(function(res){
			//console.log(res)
			self.backtestStatusMsg = res.msg
			self.backtestStatusCode = res.status
		},function(err){
			console.log(err)
		})
	}

	breakBacktest(){
		BuildApi.breakBacktest().then(function(res){
			//console.log(res)
		},function(err){
			console.log(err)
		})
	}

	validateEtfs = (etfs, timestamp) => {

		let hasData = false
		for (var i = 0; i < etfs.length; i++) {
			if(etfs[i].length > 2){
				hasData = true
			}
		}
		if(!hasData){
			return Promise.reject(false)
		}

		let secs = Date.parse(timestamp) / 1000
		return BuildApi.validateEtfs(etfs, secs).then(function(result){

			return Promise.resolve(result)
			// console.log("-=-=-=-=-",self.sectors);

		},function(err){

			console.log(err);
			return Promise.reject(false)
		})
		// console("TODO IMPLEMENT")
	}
	// removeSector(){

	// }
}

export default new BuildStore()



// WEBPACK FOOTER //
// ./src/js/store/BuildStore.js